function renderTradeIns(errorshow) {
 // console.log('workwo',errorshow);
  let emptydiv = document.querySelector('.trad-in-cart-div.ifcartempty');
  if(errorshow != null){
    errorshow = errorshow;
  }else{
    errorshow = '';
  }

  let storedData = localStorage.getItem("customProducts");
  let recJson = atob(storedData);
  var recProducts = JSON.parse(recJson);
  //recProducts = recProducts.flat();
  var recHtml = '';
  

  if (Array.isArray(recProducts) && recProducts.length > 0) {
    recHtml += '<div class="minicart_rel_product">';
    recHtml += '<div class="minicart_rel_product_title">';
    recHtml += '<h2>Your Trade-Ins</h2>';
    recHtml += '</div>';
    recHtml += '<div class="minicart_rel_product_wrap">';
    recProducts.forEach(function (recProduct, index) {
      var ski = recProduct.skiData;
      console.log('recProduct',recProduct)
      var imageURL = ski.imgUrl?.value;
      if(imageURL){
         imageurl = imageURL;
      }else{
       var imageurl = 'https://cdn.shopify.com/s/files/1/0286/7439/2148/files/image_24.png?v=1759250058';
      }
      //console.log('recProduct',recProduct)
      // console.log('recProductsss',ski.imgUrl.value)
      recHtml += '<div class="col" data-index="' + index + '">';
      recHtml += '<div class="col-wrap">';
      recHtml += '<div class="product-image">';
      recHtml += '<div class="image-ski">';
      recHtml += '<img src="' + imageurl + '" alt="Trade-in">';
      recHtml += '</div>';
      recHtml += '<div class="heading-text"><h3>' + (ski.model.value || 'No Model') + '</h3><span class="sizevalue"><strong>Size</strong>:' + ( ski.size.value ) + '<span></div>';
      recHtml += '</div>';
      recHtml += '<div class="product-details">';
      recHtml += '<p><strong>Condition:</strong> ' + (ski.condition.value || '') + '</p>';
      recHtml += '<p><strong>Bindings:</strong> ' + (ski.bindings.value || '') + '</p>';
      recHtml += '<p><strong>Year:</strong> ' + (ski.year.value || '') + '</p>';
      recHtml += '<p><strong>Brand:</strong> ' + (ski.brand.value || '') + '</p>'; 
      recHtml += '</div>';
      recHtml += '<div class="remove-button"><button class="remove-tradein link" data-index="' + index + '">Remove</button></div>';
      recHtml += '<div class="product-price"><p><strong>Price:</strong> $' + (recProduct.totalAmount?.price || recProduct.totalAmount?.value || 'USD') + '</p></div>';
      recHtml += '</div></div>';
     
    });
    recHtml += `</div><span class="bottom-title bottom-cart" id="errordiv">${errorshow}</span></div>`;
  }

  const container = document.querySelector('.trad-in-cart-div');
  if (container) {
    container.innerHTML = recHtml;
    if(emptydiv){
      emptydiv.style.display = "block";
    }
  }
}


function renderTradeprice(pricevalue) {
  let totalPrice = 0; 
  
  var storedData = localStorage.getItem('customProducts');
  if (!storedData) return;

  let recJson = atob(storedData);
  var recProducts = JSON.parse(recJson);
  var currency = 'USD'; // default

  recProducts.forEach(product => {
    let rawPrice = product?.totalAmount?.price || product?.totalAmount?.value;

    if (product?.totalAmount?.currency) {
      currency = product.totalAmount.currency;
    }

    if (rawPrice) {
      let numericPrice = parseFloat(rawPrice.replace(/[^0-9.]/g, ''));
      if (!isNaN(numericPrice)) {
        totalPrice += numericPrice;
      }
    }
  });

  let formattedPrice = totalPrice.toFixed(2);
  let container = document.querySelector('.trade-in-value p.main-price');
  let containerspan = document.querySelector('.trade-in-value span');
  let subtotalprice = document.querySelector('.checkout-subtotal-container .subtotal')?.getAttribute('data-subtotal') || '0';

  const addclasshide =  document.querySelector('.custom-right-drawer');
  
  //console.log('subtotalprice',subtotalprice)
  const containersubtotal = document.querySelector('.trade-in-value-subtotal-cart .subtotal-main-price');
  const containerspansubtotal = document.querySelector('.trade-in-value-subtotal-cart span');
  const checkoutbtnshowhide = document.querySelector('.custm-cart');
  const checkoutbtnmain = document.querySelector('.checkout-col');
  const maindivsubtotoal = document.querySelector('.trade-in-value');
  const maindivtotal = document.querySelector('.trade-in-value-subtotal-cart');

  const subtotalNum = parseFloat(subtotalprice.replace(/,/g, ""));
  const formattedNum = Number(formattedPrice);

  const subtotalpricefinal = subtotalNum - formattedNum;
  //console.log('subtotalNum:', subtotalNum+'${currency}',+formattedNum);
  //${currency}
  const subtotalpricefinalprice = subtotalpricefinal.toFixed(2);

  if(subtotalpricefinalprice.includes('-')){
    let priceWithoutMinus = Math.abs(parseFloat(subtotalpricefinalprice)).toFixed(2);
    function subtotalnumbercart() {
      containersubtotal.innerHTML = `-$${priceWithoutMinus}`;
    }
  }else{
    let priceWithoutMinus = Math.abs(parseFloat(subtotalpricefinalprice)).toFixed(2);
    function subtotalnumbercart() {
      containersubtotal.innerHTML = `$${priceWithoutMinus}`;
    }
  }


  if(container){
  if (formattedPrice !== '0.00') {
    containerspan.innerHTML = 'Estimated Trade-Ins Subtotal:';
    container.innerHTML = `-$${formattedPrice}`;
    containerspansubtotal.innerHTML = 'Estimated Total After Trade-Ins: ';
    subtotalnumbercart();
    //containersubtotal.innerHTML = `$${subtotalpricefinalprice}`;
    document.querySelector('.checkout-subtotal-container .subtotal .titleSubtotal').innerHTML = 'Estimated Total Today:';
    maindivsubtotoal.style.display = "flex";
    maindivtotal.style.display = "flex";
    checkoutbtnmain.style.display = "none";
    checkoutbtnshowhide.style.display = "block";
    if (addclasshide) {
      addclasshide.classList.add('customski-hideclass');
    }
  }else{
    containerspan.innerHTML = '';
    container.innerHTML = '';
    containersubtotal.innerHTML = '';
    containerspansubtotal.innerHTML = '';
    document.querySelector('.checkout-subtotal-container .subtotal .titleSubtotal').innerHTML = 'Subtotal:';
    maindivsubtotoal.style.display = "none";
    maindivtotal.style.display = "none";
    checkoutbtnmain.style.display = "block";
    checkoutbtnshowhide.style.display = "none";
    if (addclasshide) {
      addclasshide.classList.remove('customski-hideclass');
    }
  } 
  }
}


// Remove item on click
document.addEventListener('click', function (e) {
  if (e.target && e.target.classList.contains('remove-tradein')) {
    e.preventDefault(); 
    e.stopPropagation();
    var index = parseInt(e.target.getAttribute('data-index'));
    var encoded = localStorage.getItem('customProducts');
    let decoded = atob(encoded);
    let recProducts = JSON.parse(decoded);
    //console.log('recProducts', recProducts);
    if (Array.isArray(recProducts)) {
      var removedProduct = recProducts[index];
      var thisprice = removedProduct?.storecurrency?.price;
      //console.log('thisprice', thisprice);
      recProducts.splice(index, 1);
      var newEncoded = btoa(JSON.stringify(recProducts));
      localStorage.setItem('customProducts', newEncoded);
      var errorpass = '<p style="color:red">Your Ski trade has been removed successfully.</p>';
      tradefunctioncart();
      const removerec = [];
      fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          trade_in_products: JSON.stringify(removerec)
        }
      })
    })

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          trade_in_products: JSON.stringify(' ')
        }
      })
    })
    }
  }
});


function tradefunctioncart() {
  let count = 0;
  let prodPrice = 0;
  let arrayleng;
  let cartItemcount = 0;

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      let itemcount = cart.item_count;
      if (itemcount === 0) {
        var errorpass = '<p style="color:red">Your cart is empty. Please add a Ski to your cart to proceed with the trade-in.</p>';
        renderTradeIns(errorpass);
        setTimeout(function () {
          renderTradeprice();
        }, 1000);
      } else if (itemcount >= 1) {
        cart.items.forEach(item => {
          //console.log('ProductItem:', cart.items);
          fetch(`/products/${item.handle}.js`)
            .then(res => res.json())
            .then(product => {
              let producttags = product.tags;
              let productPrice = product.price;
              var countItem = localStorage.getItem('customProducts');
              let recJsonss = atob(countItem);
              if (recJsonss) {
                var itemsArray = JSON.parse(recJsonss);
                arrayleng = itemsArray.length;
              }
              for (let i = 0; i < producttags.length; i++) {
                if (
                  producttags[i].includes('Ski - Carving') ||
                  producttags[i].includes('Ski - All Mountain') ||
                  producttags[i].includes('JR Ski') ||
                  producttags[i].includes('SKI FLAT') ||
                  producttags[i].includes('AT SKI')
                ) {
                  count++; 
                  prodPrice += productPrice;
                  cartItemcount += item.quantity;
                  break;
                }
              }
              let checkbtnhide = document.getElementById('custom-checkout');


              if (count === 0) {
                errorpass = '<p style="color:red">Add a Ski to apply Trade-in value. Trade-in values are only applicable when purchasing another pair of skis. Trade-in values do not apply to other categories of products and are subject to adjustment upon receipt of your old skis.</p>';
                renderTradeIns(errorpass);
                if (checkbtnhide) {
                 //checkbtnhide.style.display = 'none';
                 checkbtnhide.style.opacity = '.3';
                 checkbtnhide.style.pointerEvents = 'none';
                }
                console.log('checkbtnhide',checkbtnhide)
              } else if (cartItemcount < arrayleng) {
                errorpass = "<p style='color:red'>You can trade in only one ski for each ski order.</p>";
                if (checkbtnhide) {
                  //checkbtnhide.style.display = 'none';
                  checkbtnhide.style.opacity = '.3';
                  checkbtnhide.style.pointerEvents = 'none';
                }
                renderTradeIns(errorpass);
              } else if (cartItemcount >= arrayleng) {
                errorpass = "<p style='color:#22c08d'>You're eligible for a trade-in.</p>";
                renderTradeIns(errorpass);
                if (checkbtnhide) {
                 //checkbtnhide.style.display = 'block';
                 checkbtnhide.style.opacity = '1';
                 checkbtnhide.style.pointerEvents = 'auto';
                }
              }
            })
        })
      }
      setTimeout(function () {
        renderTradeprice();
      }, 1000)
    })
    .catch(err => console.error('Error fetching cart:', err));
}



document.addEventListener('DOMContentLoaded', function () {
  tradefunctioncart();
});


const CHECKOUT_URL = '/checkout';
const CART_API_URL = '/cart.js';
const UPDATE_CART_API_URL = '/cart/update.js';

const ERROR_MESSAGES = Object.freeze({
  noSkis: "Add a Ski to apply Trade-in value. Trade-in values are only applicable when purchasing skis.",
  lowSubtotal: "Your trade-in value must be less than the cart subtotal.",
  tooManyTradeIns: "You can trade in only one ski for each ski order.",
  tradeInExceedsSkiPrice: "The trade-in value cannot exceed the price of the ski in the cart.",
  lowtradeprice:"Your trade-in value must be less than the cart subtotal."
});

// Cache DOM and static data
const DOM = Object.freeze({
  errorBox: document.querySelector('.checkout-error'),
  subtotal: parseFloat((document.querySelector('.checkout-subtotal-container .subtotal')?.getAttribute('data-subtotal') || '0').replace(/,/g, '')),
  customCheckoutText: document.getElementById('custom-checkout')
});


async function checkcartproduct() {
  let skiCount = 0;
  let localCount = 0;
  let recProducts = [];
  let skiproductPrice = 0; 
  let getcartquantity = 0;
  let cartimm;

  // ----- LocalStorage count -----
  let storedData = localStorage.getItem("customProducts");
  if (storedData) {
    try {
      let recJson = atob(storedData);
      recProducts = JSON.parse(recJson);
      localCount = Array.isArray(recProducts) ? recProducts.length : 0;
    } catch (err) {
    }
  } else {
    console.log("No customProducts found in localStorage.");
  }

  fetch(CART_API_URL)
    .then(res => res.json())
    .then(cart => {
      if (cart.item_count === 0) {
        console.log('Cart is empty.');
        return;
      }
      cartimm = cart.items;
      console.log('cart', cart.items);
      return Promise.all(
        cart.items.map(item =>
          fetch(`/products/${item.handle}.js`).then(res => res.json())
        )
      );
    })
    .then(products => {
      if (!products) return;
      products.forEach(product => {
        if (product.tags.some(tag => tag.toLowerCase().includes('ski') || 
            tag.toLowerCase().includes('ski - carving') ||
            tag.toLowerCase().includes('ski - all mountain') ||
            tag.toLowerCase().includes('jr ski') ||
            tag.toLowerCase().includes('ski flat') ||
            tag.toLowerCase().includes('at ski'))) {
          const cartItem = cartimm.find(item => item.handle === product.handle);
          const quantity = cartItem.quantity;
          skiCount += quantity;
          skiproductPrice += cartItem.original_line_price;
        }
      });

      let errorBox = document.querySelector('.checkout-error');
      let subtotalpricesss = document.querySelector('.checkout-subtotal-container .subtotal').getAttribute('data-subtotal');
      let subtotalnumm = parseFloat(subtotalpricesss.replace(/,/g, ""));

      let totalPricetrdade = 0;

      var storedData = localStorage.getItem('customProducts');
      if (!storedData) return;

      let recJson = atob(storedData);
      var recProducts = JSON.parse(recJson);
      var currency = 'USD'; // default

      recProducts.forEach(product => {
        let rawPrice = product?.totalAmount?.price || product?.totalAmount?.value;
       // console.log('rawPrice',rawPrice);
       // console.log('product',product)
        if (product?.totalAmount?.currency) {
          currency = product.totalAmount.currency;
        }
        if (rawPrice) {
          let numericPrice = parseFloat(rawPrice.replace(/[^0-9.]/g, ''));
          if (!isNaN(numericPrice)) {
            totalPricetrdade += numericPrice;
          }
        }
      });

      let formattedPricetade = totalPricetrdade.toFixed(2);
      const customcheckouttext = document.getElementById("custom-checkout");
      //let skiproprice = skiproductPrice / 100;
      
      if (errorBox) errorBox.innerHTML = '';
      if (skiCount > 0) {
        if (skiCount === 0) {
          showErrorMessage(ERROR_MESSAGES.noSkis);
        } else if (totalPricetrdade > subtotalnumm) {
          showErrorMessage(ERROR_MESSAGES.lowSubtotal);
        } else if (localCount > skiCount) {
          showErrorMessage(ERROR_MESSAGES.tooManyTradeIns);
        } else if (subtotalnumm > formattedPricetade) {
          document.getElementById("custom-checkout").innerText = 'Checkout...';
          fetch(UPDATE_CART_API_URL, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              attributes: {
                trade_in_products: JSON.stringify(recProducts)
              }
            })
          })
          .then(res => res.json())
          .then(data => {
            console.log("Cart updated with trade-in data:", data.attributes);
            window.location.href = CHECKOUT_URL;
          })
          .catch(err => console.error("Error updating cart attributes:", err));
        } else {
          showErrorMessage(ERROR_MESSAGES.lowtradeprice);
        }
      } else {
        showErrorMessage(ERROR_MESSAGES.noSkis);
      }

      if (totalPricetrdade > skiproductPrice) {
        showErrorMessage(ERROR_MESSAGES.tradeInExceedsSkiPrice);
      }
      //console.log('skiproprice', skiproprice);
      console.log('formattedPricetade', totalPricetrdade);
    })
    .catch(err => console.error(err));
}

async function showErrorMessage(message) {
  const errorBox = document.querySelector('.checkout-error');
  if (errorBox) {
    errorBox.innerHTML = `<p style="color:red;">${message}</p>`;
  }
}

document.addEventListener('DOMContentLoaded', function () {
 addCheckoutListener()
});

async function addCheckoutListener(){
  const customcheckout = document.getElementById("custom-checkout");
    if (customcheckout) {
      customcheckout.addEventListener("click", function (event) {
        event.preventDefault();
        //console.log('work');
        checkcartproduct();
      });
    }
}

//trade mail js

document.addEventListener("DOMContentLoaded", function () {
   let urlParams = window.location.href;
   console.log('urlParams',urlParams)

   let newUrl = new URLSearchParams(window.location.search);

   if (newUrl.has('tradeNumber')) {
   let tradeNumber = urlParams.split("=");
   let tradNumberget = tradeNumber[1];
   let tradNumbergetsss = tradNumberget.split('?')[0];
   let tradeid = tradeNumber[2];

   //console.log('tradNumbergetsss',tradNumbergetsss);
   //console.log('tradeid',tradeid);

    if (!tradNumbergetsss) {
        console.log("No tradeNumber found in URL");
        return;
    }
    let storedData = localStorage.getItem("customProducts");
    if (!storedData) {
        console.log("No data found in localStorage for key 'customProducts'");
        if (tradeid) {
            //console.log("Calling gettrade with tradeid:", tradeid);
            gettrade(tradeid);
        }
        return;
    }
    try {
        let decodedData = atob(storedData);
        let recJson = JSON.parse(decodedData);
         console.log("Stored Products:", recJson);
        //console.log('tradNumberget',tradNumbergetsss)
        let found = recJson.find(item => {
            let tradeNumberitem = item.tradeNumber.value || item.tradeNumber
            console.log('tradeNumberitem',tradeNumberitem);
            console.log('tradNumbergetsss',tradNumbergetsss);
            return tradeNumberitem === tradNumbergetsss;
        });
        //console.log('found',found)
        if (found) {
            console.log("TradeNumber match found:", found);
        } else {
            console.log("TradeNumber not found in localStorage:", tradeNumber);
            if (tradeid) {
                console.log("Calling gettrade with tradeid:", tradeid);
                gettrade(tradeid);
            } else {
                console.log("No tradeid found in URL to fetch data");
            }
        }
    } catch (err) {
        console.error("Error parsing localStorage data:", err);
    }
   }else{
     //console.log('NOOO')
   }

});

function gettrade(tradeid) {
  fetch("/apps/proxy/getById", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ id: tradeid })
  })
    .then(res => {
      if (!res.ok) {
        throw new Error("Failed to fetch trade data");
      }
      return res.json();
    })
    .then(data => {
    //console.log("Database Response:", data);
    console.log("response", data.data);
      let response = data.data;
      let existingData = localStorage.getItem('customProducts');
      let productArray = [];
      if (existingData) {
        try {
          const parsedData = JSON.parse(atob(existingData));
          productArray = Array.isArray(parsedData) ? parsedData : [parsedData]; // Ensure it is an array
        } catch (e) {
          productArray = [];
        }
      }
      const newTradeData = {
        customerData:{
          //value: response.customerData
          name: response.customerData.name,
          email: response.customerData.email
        },
        skiData:{
            brand: {
              value: response.skiData.brand,
            },
            year: {
             value: response.skiData.year,
            },
            model: {
             value: response.skiData.model,
            },
            bindings: {
             value: response.skiData.bindings,
            },
            condition: {
             value: response.skiData.condition,
            },
            imgUrl:{
             value: response.skiData.imgUrl,
            },
            size:{
            value: response.skiData.size
            },
            payment_type: {
              value: response.skiData.paymentMethod
            }
         },
        statustrade: {
          value: response.statustrade
        },
        tradeNumber:response.tradeNumber,
        totalAmount: response.totalAmount,
      };

      //console.log('newTradeData',newTradeData);
      productArray.push(newTradeData);
      const secretData = JSON.stringify(productArray);
      const encodedData = btoa(secretData);
      console.log('secretData',data.skiData);
      console.log('secretData',secretData);
      localStorage.setItem('customProducts', encodedData);
      window.location.href = '/cart';

    })
    .catch(err => {
      console.error("Error fetching trade data:", err);
    });
}


